// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1z3XJ","right":"styles_right__1ozg2"};